import { useState } from "react";
import { Box, Paper, Button, Typography, CircularProgress, Alert } from "@mui/material";

// Re-export so other files can do: import { ScraperControl } from '.../Dashboard'
export { default as ScraperControl } from "./ScraperControl";

const WEBTUNES_BASE = "https://webtunes.com";
const ADMIN_SECRET  = process.env.REACT_APP_ADMIN_SECRET || "";

function TrendingVenuesRefresh() {
  const [status, setStatus] = useState(null); // null | "loading" | "ok" | "error"
  const [result, setResult] = useState(null);

  const handleRefresh = async () => {
    setStatus("loading");
    setResult(null);
    try {
      const url = `${WEBTUNES_BASE}/api/admin/refresh-trending-venues?secret=${ADMIN_SECRET}`;
      const res = await fetch(url, { method: "POST" });
      const data = await res.json();
      if (res.ok && data.ok) {
        setStatus("ok");
        setResult(`Updated ${data.venueCount} trending venues.`);
      } else {
        setStatus("error");
        setResult(data.error || "Unknown error");
      }
    } catch (err) {
      setStatus("error");
      setResult(err.message);
    }
  };

  return (
    <Paper sx={{ p: 2.5, border: "1px solid #e0e0e0", maxWidth: 420 }}>
      <Typography variant="h6" sx={{ mb: 0.5, fontWeight: 700 }}>
        Trending Venue Schedules
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
        Refreshes the homepage "Trending Venues" section from GA4 data (last 7 days).
        Run once a week.
      </Typography>
      <Button
        variant="contained"
        onClick={handleRefresh}
        disabled={status === "loading"}
        startIcon={status === "loading" ? <CircularProgress size={16} color="inherit" /> : null}
      >
        {status === "loading" ? "Refreshing…" : "Refresh Trending Venues"}
      </Button>
      {status === "ok"    && <Alert severity="success" sx={{ mt: 2 }}>{result}</Alert>}
      {status === "error" && <Alert severity="error"   sx={{ mt: 2 }}>{result}</Alert>}
    </Paper>
  );
}

const Dashboard = () => (
  <Box sx={{ p: 3 }}>
    <TrendingVenuesRefresh />
  </Box>
);

export default Dashboard;
